import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import LoadTimeEntry from './LoadTimeEntry';

const LoadModal = ({ open, toggle, projectList }) => {
  const DialogWrapper = styled(Dialog)(
    () => `
              .MuiDialog-container {
                  height: 100vh;
              }
              
              .MuiDialog-paperScrollPaper {
                  max-height: calc(100vh - 80px)
              }
          `
  );
  return (
    <DialogWrapper
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <LoadTimeEntry toggle={toggle} projectList={projectList}/>
    </DialogWrapper>
  );
};

export default LoadModal;
